// src/components/CustomTextFieldWithWordCounter.js
import React from "react";
import { Box, TextField, Typography } from "@mui/material";

/**
 * CustomTextFieldWithWordCounter
 *
 * Responsibility:
 *  - Render the multiline text field
 *  - Draw the border with given color + style
 *  - Show "X / Y words" inside the bottom-right corner
 */
export default function CustomTextFieldWithWordCounter({
  value,
  onChange,
  label,
  wordCount,
  hardLimit,
  minRows = 6,
  borderColor = "#bdbdbd",
  borderStyle = "solid",
  ...props
}) {
  return (
    <Box sx={{ position: "relative" }}>
      <TextField
        fullWidth
        multiline
        variant="outlined"
        minRows={minRows}
        label={label}
        value={value}
        onChange={onChange}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor,
              borderStyle,
            },
            "&:hover fieldset": {
              borderColor,
              borderStyle,
            },
            "&.Mui-focused fieldset": {
              borderColor,
              borderStyle,
            },
          },
          // Extra padding at the bottom so that the counter
          // doesn't overlap with user text.
          "& .MuiOutlinedInput-inputMultiline": {
            paddingBottom: "2.4em",
          },
        }}
        {...props}
      />

      {/* Word counter inside the text field */}
      <Typography
        variant="caption"
        sx={{
          position: "absolute",
          right: 16,
          bottom: 10,
          pointerEvents: "none",
          fontSize: "0.75rem",
          color: "#424242",
          backgroundColor: "rgba(255,255,255,0.8)",
          padding: "0 4px",
        }}
      >
        {wordCount} / {hardLimit} words
      </Typography>
    </Box>
  );
}
